import { TipDetail, WorkDay } from '@core/models';
import { IIntegerPrecisionService } from '@core/interfaces/integer-precision-service.interface';
import { TipCalculationStrategy } from '../interfaces/tip-calculation-strategy.interface';

export class PercentageTipStrategy implements TipCalculationStrategy {
	calculateAmount(
		tip: TipDetail,
		subtotal: bigint,
		precisionService: IIntegerPrecisionService,
		workDay: WorkDay
	): bigint {
		if (tip.percent) {
			return precisionService.calculatePercentage(
				subtotal,
				(tip.percent * 100).toString(),
				workDay
			);
		}

		if (!tip.valor) {
			return 0n;
		}

		const percentage = precisionService.toDecimalStringFromInternal(
			tip.valor,
			workDay
		);
		return precisionService.calculatePercentage(
			subtotal,
			percentage,
			workDay
		);
	}

	calculateOption(
		tip: TipDetail,
		subtotal: bigint,
		precisionService: IIntegerPrecisionService,
		workDay: WorkDay
	): TipDetail {
		const percentValue = precisionService.toDecimalStringFromInternal(
			tip.valor,
			workDay
		);
		const amount = precisionService.calculatePercentage(
			subtotal,
			percentValue,
			workDay
		);

		return {
			...tip,
			percent: Number(percentValue),
			value: precisionService.toDecimalNumberFromInternal(amount, workDay),
		};
	}
}
